import _slicedToArray from "/builds/zappy-ride/client-burbank-ev/frontend/application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/builds/zappy-ride/client-burbank-ev/frontend/application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/builds/zappy-ride/client-burbank-ev/frontend/application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/zappy-ride/client-burbank-ev/frontend/application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import KDBush from 'kdbush';
var defaultOptions = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: false,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: false,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: function map(props) {
    return props;
  } // props => ({sum: props.my_value})

};

var Supercluster = /*#__PURE__*/function () {
  function Supercluster(options) {
    _classCallCheck(this, Supercluster);

    this.options = extend(Object.create(defaultOptions), options);
    this.trees = new Array(this.options.maxZoom + 1);
  }

  _createClass(Supercluster, [{
    key: "load",
    value: function load(points) {
      var _this$options = this.options,
          log = _this$options.log,
          minZoom = _this$options.minZoom,
          maxZoom = _this$options.maxZoom,
          nodeSize = _this$options.nodeSize;
      if (log) console.time('total time');
      var timerId = "prepare ".concat(points.length, " points");
      if (log) console.time(timerId);
      this.points = points; // generate a cluster object for each point and index input points into a KD-tree

      var clusters = [];

      for (var i = 0; i < points.length; i++) {
        if (!points[i].geometry) continue;
        clusters.push(createPointCluster(points[i], i));
      }

      this.trees[maxZoom + 1] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
      if (log) console.timeEnd(timerId); // cluster points on max zoom, then cluster the results on previous zoom, etc.;
      // results in a cluster hierarchy across zoom levels

      for (var z = maxZoom; z >= minZoom; z--) {
        var now = +Date.now(); // create a new set of clusters for the zoom and index them with a KD-tree

        clusters = this._cluster(clusters, z);
        this.trees[z] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
        if (log) console.log('z%d: %d clusters in %dms', z, clusters.length, +Date.now() - now);
      }

      if (log) console.timeEnd('total time');
      return this;
    }
  }, {
    key: "getClusters",
    value: function getClusters(bbox, zoom) {
      var minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
      var minLat = Math.max(-90, Math.min(90, bbox[1]));
      var maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
      var maxLat = Math.max(-90, Math.min(90, bbox[3]));

      if (bbox[2] - bbox[0] >= 360) {
        minLng = -180;
        maxLng = 180;
      } else if (minLng > maxLng) {
        var easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
        var westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
        return easternHem.concat(westernHem);
      }

      var tree = this.trees[this._limitZoom(zoom)];

      var ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
      var clusters = [];

      var _iterator = _createForOfIteratorHelper(ids),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var id = _step.value;
          var c = tree.points[id];
          clusters.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return clusters;
    }
  }, {
    key: "getChildren",
    value: function getChildren(clusterId) {
      var originId = this._getOriginId(clusterId);

      var originZoom = this._getOriginZoom(clusterId);

      var errorMsg = 'No cluster with the specified id.';
      var index = this.trees[originZoom];
      if (!index) throw new Error(errorMsg);
      var origin = index.points[originId];
      if (!origin) throw new Error(errorMsg);
      var r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
      var ids = index.within(origin.x, origin.y, r);
      var children = [];

      var _iterator2 = _createForOfIteratorHelper(ids),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var id = _step2.value;
          var c = index.points[id];

          if (c.parentId === clusterId) {
            children.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (children.length === 0) throw new Error(errorMsg);
      return children;
    }
  }, {
    key: "getLeaves",
    value: function getLeaves(clusterId, limit, offset) {
      limit = limit || 10;
      offset = offset || 0;
      var leaves = [];

      this._appendLeaves(leaves, clusterId, limit, offset, 0);

      return leaves;
    }
  }, {
    key: "getTile",
    value: function getTile(z, x, y) {
      var tree = this.trees[this._limitZoom(z)];

      var z2 = Math.pow(2, z);
      var _this$options2 = this.options,
          extent = _this$options2.extent,
          radius = _this$options2.radius;
      var p = radius / extent;
      var top = (y - p) / z2;
      var bottom = (y + 1 + p) / z2;
      var tile = {
        features: []
      };

      this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.points, x, y, z2, tile);

      if (x === 0) {
        this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.points, z2, y, z2, tile);
      }

      if (x === z2 - 1) {
        this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.points, -1, y, z2, tile);
      }

      return tile.features.length ? tile : null;
    }
  }, {
    key: "getClusterExpansionZoom",
    value: function getClusterExpansionZoom(clusterId) {
      var expansionZoom = this._getOriginZoom(clusterId) - 1;

      while (expansionZoom <= this.options.maxZoom) {
        var children = this.getChildren(clusterId);
        expansionZoom++;
        if (children.length !== 1) break;
        clusterId = children[0].properties.cluster_id;
      }

      return expansionZoom;
    }
  }, {
    key: "_appendLeaves",
    value: function _appendLeaves(result, clusterId, limit, offset, skipped) {
      var children = this.getChildren(clusterId);

      var _iterator3 = _createForOfIteratorHelper(children),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          var props = child.properties;

          if (props && props.cluster) {
            if (skipped + props.point_count <= offset) {
              // skip the whole cluster
              skipped += props.point_count;
            } else {
              // enter the cluster
              skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped); // exit the cluster
            }
          } else if (skipped < offset) {
            // skip a single point
            skipped++;
          } else {
            // add a single point
            result.push(child);
          }

          if (result.length === limit) break;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return skipped;
    }
  }, {
    key: "_addTileFeatures",
    value: function _addTileFeatures(ids, points, x, y, z2, tile) {
      var _iterator4 = _createForOfIteratorHelper(ids),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var i = _step4.value;
          var c = points[i];
          var isCluster = c.numPoints;
          var f = {
            type: 1,
            geometry: [[Math.round(this.options.extent * (c.x * z2 - x)), Math.round(this.options.extent * (c.y * z2 - y))]],
            tags: isCluster ? getClusterProperties(c) : this.points[c.index].properties
          }; // assign id

          var id = void 0;

          if (isCluster) {
            id = c.id;
          } else if (this.options.generateId) {
            // optionally generate id
            id = c.index;
          } else if (this.points[c.index].id) {
            // keep id if already assigned
            id = this.points[c.index].id;
          }

          if (id !== undefined) f.id = id;
          tile.features.push(f);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "_limitZoom",
    value: function _limitZoom(z) {
      return Math.max(this.options.minZoom, Math.min(+z, this.options.maxZoom + 1));
    }
  }, {
    key: "_cluster",
    value: function _cluster(points, zoom) {
      var clusters = [];
      var _this$options3 = this.options,
          radius = _this$options3.radius,
          extent = _this$options3.extent,
          reduce = _this$options3.reduce,
          minPoints = _this$options3.minPoints;
      var r = radius / (extent * Math.pow(2, zoom)); // loop through each point

      for (var i = 0; i < points.length; i++) {
        var p = points[i]; // if we've already visited the point at this zoom level, skip it

        if (p.zoom <= zoom) continue;
        p.zoom = zoom; // find all nearby points

        var tree = this.trees[zoom + 1];
        var neighborIds = tree.within(p.x, p.y, r);
        var numPointsOrigin = p.numPoints || 1;
        var numPoints = numPointsOrigin; // count the number of points in a potential cluster

        var _iterator5 = _createForOfIteratorHelper(neighborIds),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _neighborId2 = _step5.value;
            var _b2 = tree.points[_neighborId2]; // filter out neighbors that are already processed

            if (_b2.zoom > zoom) numPoints += _b2.numPoints || 1;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        if (numPoints >= minPoints) {
          // enough points to form a cluster
          var wx = p.x * numPointsOrigin;
          var wy = p.y * numPointsOrigin;
          var clusterProperties = reduce && numPointsOrigin > 1 ? this._map(p, true) : null; // encode both zoom and point index on which the cluster originated -- offset by total length of features

          var id = (i << 5) + (zoom + 1) + this.points.length;

          var _iterator6 = _createForOfIteratorHelper(neighborIds),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var neighborId = _step6.value;
              var b = tree.points[neighborId];
              if (b.zoom <= zoom) continue;
              b.zoom = zoom; // save the zoom (so it doesn't get processed twice)

              var numPoints2 = b.numPoints || 1;
              wx += b.x * numPoints2; // accumulate coordinates for calculating weighted center

              wy += b.y * numPoints2;
              b.parentId = id;

              if (reduce) {
                if (!clusterProperties) clusterProperties = this._map(p, true);
                reduce(clusterProperties, this._map(b));
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          p.parentId = id;
          clusters.push(createCluster(wx / numPoints, wy / numPoints, id, numPoints, clusterProperties));
        } else {
          // left points as unclustered
          clusters.push(p);

          if (numPoints > 1) {
            var _iterator7 = _createForOfIteratorHelper(neighborIds),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _neighborId = _step7.value;
                var _b = tree.points[_neighborId];
                if (_b.zoom <= zoom) continue;
                _b.zoom = zoom;
                clusters.push(_b);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }
        }
      }

      return clusters;
    } // get index of the point from which the cluster originated

  }, {
    key: "_getOriginId",
    value: function _getOriginId(clusterId) {
      return clusterId - this.points.length >> 5;
    } // get zoom of the point from which the cluster originated

  }, {
    key: "_getOriginZoom",
    value: function _getOriginZoom(clusterId) {
      return (clusterId - this.points.length) % 32;
    }
  }, {
    key: "_map",
    value: function _map(point, clone) {
      if (point.numPoints) {
        return clone ? extend({}, point.properties) : point.properties;
      }

      var original = this.points[point.index].properties;
      var result = this.options.map(original);
      return clone && result === original ? extend({}, result) : result;
    }
  }]);

  return Supercluster;
}();

export { Supercluster as default };

function createCluster(x, y, id, numPoints, properties) {
  return {
    x: x,
    // weighted cluster center
    y: y,
    zoom: Infinity,
    // the last zoom the cluster was processed at
    id: id,
    // encodes index of the first child of the cluster and its zoom level
    parentId: -1,
    // parent cluster id
    numPoints: numPoints,
    properties: properties
  };
}

function createPointCluster(p, id) {
  var _p$geometry$coordinat = _slicedToArray(p.geometry.coordinates, 2),
      x = _p$geometry$coordinat[0],
      y = _p$geometry$coordinat[1];

  return {
    x: lngX(x),
    // projected point coordinates
    y: latY(y),
    zoom: Infinity,
    // the last zoom the point was processed at
    index: id,
    // index of the source feature in the original input array,
    parentId: -1 // parent cluster id

  };
}

function getClusterJSON(cluster) {
  return {
    type: 'Feature',
    id: cluster.id,
    properties: getClusterProperties(cluster),
    geometry: {
      type: 'Point',
      coordinates: [xLng(cluster.x), yLat(cluster.y)]
    }
  };
}

function getClusterProperties(cluster) {
  var count = cluster.numPoints;
  var abbrev = count >= 10000 ? "".concat(Math.round(count / 1000), "k") : count >= 1000 ? "".concat(Math.round(count / 100) / 10, "k") : count;
  return extend(extend({}, cluster.properties), {
    cluster: true,
    cluster_id: cluster.id,
    point_count: count,
    point_count_abbreviated: abbrev
  });
} // longitude/latitude to spherical mercator in [0..1] range


function lngX(lng) {
  return lng / 360 + 0.5;
}

function latY(lat) {
  var sin = Math.sin(lat * Math.PI / 180);
  var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
  return y < 0 ? 0 : y > 1 ? 1 : y;
} // spherical mercator to longitude/latitude


function xLng(x) {
  return (x - 0.5) * 360;
}

function yLat(y) {
  var y2 = (180 - y * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

function extend(dest, src) {
  for (var id in src) {
    dest[id] = src[id];
  }

  return dest;
}

function getX(p) {
  return p.x;
}

function getY(p) {
  return p.y;
}